<template>
  <div class="profile">
    <div class="container">
      <div class="profile__wrapper">
        <update-form v-if="isEditProfile" />
        <profile-card v-else />
        <profile-orders />
      </div>
    </div>
  </div>
</template>

<script setup>
import ProfileCard from "@/components/profile/profile-card.vue";
import ProfileOrders from "@/components/profile/profile-orders.vue";
import {useRoute} from "vue-router";
import {computed} from "vue";
import UpdateForm from "@/components/forms/update-form.vue";

const route = useRoute()

const isEditProfile = computed(() => {
  return route.query.edit ? route.query.edit : false
})
</script>

<style lang="scss" scoped>
.profile {
  background-image: url(@images/bg/profileBg.png);
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;

  &__wrapper {
    display: flex;
    align-items: flex-start;
    gap: 100px;
  }
}

@media (max-width: 1300px) {
  .profile {
    &__wrapper {
      flex-direction: column;
      align-items: center;
      gap: 0;
    }
  }
}
</style>